import { casinoData } from '@/mocks/casinos';
import { trackRegisterClick } from '@/utils/analytics';

const PROMO_GIF_URL = 'https://xt30sf.b-cdn.net/media/096f34d544696476a881d.gif';

function getRandomBrand() {
  return casinoData[Math.floor(Math.random() * casinoData.length)];
}

export default function FloatingBrandPromo() {
  const handleClick = () => {
    const brand = getRandomBrand();

    trackRegisterClick({
      brandName: brand.name,
      brandSlug: brand.slug,
      registerUrl: brand.registerUrl,
      source: 'floating_promo',
    });

    window.open(brand.registerUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Claim free credits - random partner offer"
      className="fixed right-0 top-1/2 z-50 -translate-y-1/2 p-0 border-0 bg-transparent cursor-pointer hover:opacity-95 transition-opacity"
    >
      <img
        src={PROMO_GIF_URL}
        alt="Claim free credits"
        className="block w-[72px] sm:w-[80px] md:w-[90px] h-auto"
        loading="lazy"
        decoding="async"
      />
    </button>
  );
}
